import { types } from '../actions/pwa';

const initialState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  isInstalled: false,
  showInstallPrompt: false,
  updateAvailable: false,
  deferredPrompt: null,
  lastOnlineTime: Date.now()
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.SET_ONLINE_STATUS:
      return {
        ...state,
        isOnline: action.payload,
        lastOnlineTime: action.payload ? Date.now() : state.lastOnlineTime
      };

    case types.SET_INSTALLED:
      return {
        ...state,
        isInstalled: action.payload
      };

    case types.SET_SHOW_INSTALL_PROMPT:
      return {
        ...state,
        showInstallPrompt: action.payload
      };

    case types.SET_UPDATE_AVAILABLE:
      return {
        ...state,
        updateAvailable: action.payload
      };

    case types.SET_DEFERRED_PROMPT:
      return {
        ...state,
        deferredPrompt: action.payload
      };

    default:
      return state;
  }
}
